"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userLevelsImages = void 0;
exports.userLevelsImages = {
    level0Default: '/img/userLevels/level_0.png',
    level0Small: '/img/userLevels/header_levels/level_0.png',
    level0CoctailsBig: '/img/userLevels/coctails_big/00_A.png',
    level1Default: '/img/userLevels/level_1.png',
    level1Small: '/img/userLevels/header_levels/level_1.png',
    level1CoctailsBig: '/img/userLevels/coctails_big/01_A.png',
    level2Default: '/img/userLevels/level_2.png',
    level2Small: '/img/userLevels/header_levels/header_levels/level_2.png',
    level2CoctailsBig: '/img/userLevels/coctails_big/02_A.png',
    level3Default: '/img/userLevels/level_3.png',
    level3Small: '/img/userLevels/header_levels/header_levels/level_3.png',
    level3CoctailsBig: '/img/userLevels/coctails_big/03_A.png',
    level4Default: '/img/userLevels/level_4.png',
    level4Small: '/img/userLevels/header_levels/header_levels/level_4.png',
    level4CoctailsBig: '/img/userLevels/coctails_big/04_A.png',
    level5Default: '/img/userLevels/level_5.png',
    level5Small: '/img/userLevels/header_levels/header_levels/level_5.png',
    level5CoctailsBig: '/img/userLevels/coctails_big/05_A.png',
    level6Default: '/img/userLevels/level_6.png',
    level6Small: '/img/userLevels/header_levels/header_levels/level_6.png',
    level6CoctailsBig: '/img/userLevels/coctails_big/06_A.png',
    level7Default: '/img/userLevels/level_7.png',
    level7Small: '/img/userLevels/header_levels/header_levels/level_7.png',
    level7CoctailsBig: '/img/userLevels/coctails_big/07_A.png',
    level8Default: '/img/userLevels/level_8.png',
    level8Small: '/img/userLevels/header_levels/header_levels/level_8.png',
    level8CoctailsBig: '/img/userLevels/coctails_big/08_A.png',
    level9Default: '/img/userLevels/level_9.png',
    level9Small: '/img/userLevels/header_levels/header_levels/level_9.png',
    level9CoctailsBig: '/img/userLevels/coctails_big/09_A.png',
    level10Default: '/img/userLevels/level_10.png',
    level10Small: '/img/userLevels/header_levels/header_levels/level_10.png',
    level10CoctailsBig: '/img/userLevels/coctails_big/10_A.png',
    level11Default: '/img/userLevels/level_11.png',
    level11Small: '/img/userLevels/header_levels/header_levels/level_11.png',
    level11CoctailsBig: '/img/userLevels/coctails_big/11_A.png',
    level12Default: '/img/userLevels/level_12.png',
    level12Small: '/img/userLevels/header_levels/header_levels/level_12.png',
    level12CoctailsBig: '/img/userLevels/coctails_big/12_A.png',
    level13Default: '/img/userLevels/level_13.png',
    level13Small: '/img/userLevels/header_levels/header_levels/level_13.png',
    level13CoctailsBig: '/img/userLevels/coctails_big/13_A.png',
    level14Default: '/img/userLevels/level_14.png',
    level14Small: '/img/userLevels/header_levels/header_levels/level_14.png',
    level14CoctailsBig: '/img/userLevels/coctails_big/14_A.png',
    level15Default: '/img/userLevels/level_15.png',
    level15Small: '/img/userLevels/header_levels/header_levels/level_15.png',
    level15CoctailsBig: '/img/userLevels/coctails_big/15_A.png',
    level16Default: '/img/userLevels/level_16.png',
    level16Small: '/img/userLevels/header_levels/header_levels/level_16.png',
    level16CoctailsBig: '/img/userLevels/coctails_big/16_A.png',
    level17Default: '/img/userLevels/level_17.png',
    level17Small: '/img/userLevels/header_levels/header_levels/level_17.png',
    level17CoctailsBig: '/img/userLevels/coctails_big/17_A.png',
    level18Default: '/img/userLevels/level_18.png',
    level18Small: '/img/userLevels/header_levels/header_levels/level_18.png',
    level18CoctailsBig: '/img/userLevels/coctails_big/18_A.png',
    level19Default: '/img/userLevels/level_19.png',
    level19Small: '/img/userLevels/header_levels/header_levels/level_19.png',
    level19CoctailsBig: '/img/userLevels/coctails_big/19_A.png',
    level20Default: '/img/userLevels/level_20.png',
    level20Small: '/img/userLevels/header_levels/header_levels/level_20.png',
    level20CoctailsBig: '/img/userLevels/coctails_big/20_A.png',
    level21Default: '/img/userLevels/level_21.png',
    level21Small: '/img/userLevels/header_levels/header_levels/level_21.png',
    level21CoctailsBig: '/img/userLevels/coctails_big/21_A.png',
    level22Default: '/img/userLevels/level_22.png',
    level22Small: '/img/userLevels/header_levels/header_levels/level_22.png',
    level22CoctailsBig: '/img/userLevels/coctails_big/22_A.png',
    level23Default: '/img/userLevels/level_23.png',
    level23Small: '/img/userLevels/header_levels/header_levels/level_23.png',
    level23CoctailsBig: '/img/userLevels/coctails_big/23_A.png',
    level24Default: '/img/userLevels/level_24.png',
    level24Small: '/img/userLevels/header_levels/header_levels/level_24.png',
    level24CoctailsBig: '/img/userLevels/coctails_big/24_A.png',
    level25Default: '/img/userLevels/level_25.png',
    level25Small: '/img/userLevels/header_levels/header_levels/level_25.png',
    level25CoctailsBig: '/img/userLevels/coctails_big/25_A.png',
    level26Default: '/img/userLevels/level_26.png',
    level26Small: '/img/userLevels/header_levels/header_levels/level_26.png',
    level26CoctailsBig: '/img/userLevels/coctails_big/26_A.png',
    level27Default: '/img/userLevels/level_27.png',
    level27Small: '/img/userLevels/header_levels/header_levels/level_27.png',
    level27CoctailsBig: '/img/userLevels/coctails_big/27_A.png',
    level28Default: '/img/userLevels/level_28.png',
    level28Small: '/img/userLevels/header_levels/header_levels/level_28.png',
    level28CoctailsBig: '/img/userLevels/coctails_big/28_A.png',
    level29Default: '/img/userLevels/level_29.png',
    level29Small: '/img/userLevels/header_levels/header_levels/level_29.png',
    level29CoctailsBig: '/img/userLevels/coctails_big/29_A.png',
    level30Default: '/img/userLevels/level_30.png',
    level30Small: '/img/userLevels/header_levels/header_levels/level_30.png',
    level30CoctailsBig: '/img/userLevels/coctails_big/30_A.png',
};
